import React, { useState, useCallback } from 'react';
import {variables} from '../../Variables.js';
import InputPoDelay from './InputPoDelay.jsx';
import {calculateRemainingMonths} from '../../helpers/calculate-remaining-months.js';
import {getMonths, getMonthsWithValues, getMonthsWithChecks} from '../../helpers/helpers';
import { Blocks } from 'react-loader-spinner'
import axios from 'axios';
import { useEffect } from 'react';

export default function PoDelayMonths({containerPoDelay, 
                                      fyname, 
                                      onValueChange, 
                                      onValueCheckChange,
                                      dataFromDb,
                                      edition,
                                      refreshKey
                                      }) {

    const [remainingMonths, setRemainingMonths] = useState([]);
    const allMonths = [
        { name: "July", key: 7 },
        { name: "August", key: 8 },
        { name: "September", key: 9 },
        { name: "October", key: 10 },
        { name: "November", key: 11 },
        { name: "December", key: 12 },
        { name: "January", key: 1 },
        { name: "February", key: 2 },
        { name: "March", key: 3 },
        { name: "April", key: 4 },
        { name: "May", key: 5 },
        { name: "June", key: 6 },
      ];
      


      
      const defaultInputs = (edition) ? getMonthsWithValues(dataFromDb)
                                      : allMonths.reduce((acc, month) => {
                                          acc[month.name] = '';
                                          return acc;
                                        }, {});
      const defaultCheckbox = edition ? getMonthsWithChecks(dataFromDb)
                                      : allMonths.reduce((acc, month) => {
                                          acc[month.name] = false;
                                          return acc;
                                        }, {});

      // Create a state for all month inputs
      const [monthInputs, setMonthInputs] = useState({});

                                                                    
    const [monthCheckbox, setMonthCheckboxes] = useState({});

      useEffect(() => {
        setMonthInputs(defaultInputs);
        setMonthCheckboxes(defaultCheckbox);
      }, [refreshKey]); // reset when refreshKey changes

    
      const setMonthInput = (name, value) => {
        setMonthInputs((prev) => ({
          ...prev,
          [name]: value
        }));
      };

      const setMonthCheckbox = (name, value) => {
        setMonthCheckboxes((prev) => ({
          ...prev,
          [name]: value
        }));
      };

      // Sync up to parent AFTER render to avoid setState during render warnings
      useEffect(() => {
        onValueChange(monthInputs);
      }, [monthInputs, onValueChange]);

      useEffect(() => {
        onValueCheckChange(monthCheckbox);
      }, [monthCheckbox, onValueCheckChange]);

    const calculate = useCallback(() => {
          if (typeof containerPoDelay === 'undefined' || !fyname) 
            return ;
        setRemainingMonths(calculateRemainingMonths(containerPoDelay, fyname));
      }, [containerPoDelay, fyname]);

      useEffect(() => {
        calculate();
      }, [calculate]);

      // const monthsFiltred = edition ? getMonths(dataFromDb) : allMonths.filter((month) => remainingMonths.includes(month.key));
      const monthsFiltred = edition ? getMonths(dataFromDb) : allMonths ;

      console.log('[PoDelayMonths monthsFiltred]', monthsFiltred);

    return (
      <div>
        {monthsFiltred.map((month) => (
            <InputPoDelay
              key={month.key}
              month={month.name}
              monthInput={monthInputs[month.name]}
              monthCheckbox={monthCheckbox[month.name]}
              setMonthInput={(value) => setMonthInput(month.name, value)}
              setMonthCheckbox={(value) => setMonthCheckbox(month.name, value)}
            />
        ))}
      </div>

    );
}